import AboutHero     from '../components/about/AboutHero'
import OurStory      from '../components/about/OurStory'
import WhatWeBelieve from '../components/about/WhatWeBelieve'
import Testimonials  from '../components/home/Testimonials'
import CTA           from '../components/home/CTA'

export default function About() {
  return (
    <>
      <AboutHero />
      <OurStory />
      <WhatWeBelieve />
      <Testimonials />
      <CTA />
    </>
  )
}
